// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getHomeRouteForLoggedInUser, getUserData } from '@/auth/utils'
import FAQs from '@/router/routes/FAQs'
import comments from '@/router/routes/comments'
import contentCampaigns from '@/router/routes/contentCampaigns'
import counselings from '@/router/routes/counselings'
import errors from '@/router/routes/errors'
import menu from '@/router/routes/menu'
import notifications from '@/router/routes/notifications'
import question from '@/router/routes/questions'
import specialist from '@/router/routes/specialist'
import subscriptions from '@/router/routes/subscriptions'
import suggestions from '@/router/routes/suggestions'
import testimonials from '@/router/routes/testimonials'
import themeSettings from '@/router/routes/themeSettings'
import feedbacks from '@/router/routes/feedbacks'
import router from './instance'
import tags from './routes/tags'
import services from './routes/services'
import pages from './routes/pages'
import momExperiences from './routes/momExperiences'
import managers from './routes/managers'
import dashboard from './routes/dashboard'
import articles from './routes/articles'
import users from './routes/users'
import videos from './routes/videos'
import weeks from './routes/weeks'
import units from './routes/units'

const routes = [
  { path: '/', redirect: { name: 'dashboard' } },
  ...FAQs,
  ...articles,
  ...comments,
  ...contentCampaigns,
  ...dashboard,
  ...counselings,
  ...errors,
  ...managers,
  ...momExperiences,
  ...menu,
  ...notifications,
  ...pages,
  ...question,
  ...services,
  ...specialist,
  ...subscriptions,
  ...suggestions,
  ...tags,
  ...testimonials,
  ...themeSettings,
  ...users,
  ...videos,
  ...weeks,
  ...feedbacks,
  ...units,
  {
    path: '*',
    redirect: 'error-404',
  },
]

// Register routes once during bootstrap; consumers share the independent router instance.
router.options.routes = routes
router.addRoutes(routes)

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    return next(getHomeRouteForLoggedInUser(userData ? userData.roles : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
